import {
  BlockVariation,
  InnerBlockTemplate,
  registerBlockVariation,
} from "@wordpress/blocks";
import config, { type BlockAttributes } from "./block.json";
import { SliderIcon } from "../../../source/icons";

const variations: (BlockVariation<BlockAttributes> & {
  innerBlocks: InnerBlockTemplate[];
})[] = [
  {
    name: "teaser-slider",
    title: "Teaser Slider",
    icon: SliderIcon,
    innerBlocks: [
      ["yellowtree/teaser", {}],
      ["yellowtree/teaser", {}],
      ["yellowtree/teaser", {}],
    ],
    isDefault: true,
  },
  {
    name: "news-Slider",
    title: "News Slider",
    icon: SliderIcon,
    innerBlocks: [
      ["yellowtree/news", {}],
      ["yellowtree/news", {}],
      ["yellowtree/news", {}],
    ],
  },
];

export function registerBlockVariations() {
  for (const variation of variations) {
    registerBlockVariation(config.name, {
      ...variation,
      title: variation.title,
      scope: ["inserter"],
      attributes: { template: variation.name },
      isActive: ["template"],
    });
  }
}

export default variations;
